import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { NotificationManager } from "react-notifications";
import { Formik } from "formik";
import * as yup from "yup";
import {
  getServiceForUpdate,
  editService,
} from "app/services/serviceMasterService";

import {
  RenderTextInput,
  RenderSelectInput,
  RenderTextArea,
} from "app/common/renderInput";

const validationModel = yup.object().shape({
  serviceType: yup.string().required("Service Name is required!"),
  serviceDescription: yup.string().required("Service Description is required!"),
  status: yup.boolean().required("Status is required!"),
});

const EditServiceAllocation = (props) => {
  const [formData, setFormData] = useState({
    id: 0,
    serviceType: "",
    serviceDescription: "",
    status: true,
    statusOptions: [
      { value: "true", label: "Active" },
      { value: "false", label: "Inactive" },
    ],
  });

  const loadData = async (id) => {
    try {
      const response = await getServiceForUpdate(id);
      const data = response?.data;
      console.log(data);
      setFormData((prev) => ({
        ...prev,
        serviceType: data.serviceType,
        serviceDescription: data.serviceDescription,
        status: data.status,
        id: data.id,
      }));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (props.id > 0 && formData.id !== props.id) {
      loadData(props.id);
    }
  }, [props.id, formData.id]);

  const handleSubmit = async (values) => {
    if (values.id > 0) {
      const data = {
        serviceType: values.serviceType,
        serviceDescription: values.serviceDescription,
        status: values.status,
        id: values.id,
      };
      try {
        const response = await editService(data);

        if (response.status === "Success") {
          NotificationManager.success(response.message);
          document.querySelectorAll(".btn-close")[1].click();
          props.loadNotification();
          await loadData(formData.id);
        } else {
          NotificationManager.error(response.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <div
      className="modal fade"
      id="EditNotificationModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addNewNotificationLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-md" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addNewNotificationLabel">
              Edit Service Allocation
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <Formik
            onSubmit={handleSubmit}
            initialValues={formData}
            validationSchema={validationModel}
            enableReinitialize={true}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
            }) => (
              <div className="modal-body">
                <form
                  className="needs-validation"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  <Row>
                    <RenderTextInput
                      type="text"
                      name="serviceType"
                      display="Service Name"
                      placeholder="Service Name"
                      value={values.serviceType}
                      error={errors.serviceType}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.serviceType}
                      required
                    />
                  </Row>
                  <Row className="mb-2">
                    <RenderTextArea
                      name="serviceDescription"
                      display="Service Description"
                      placeholder="Service Description"
                      value={values.serviceDescription}
                      error={errors.serviceDescription}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched.serviceDescription}
                      required
                    />
                  </Row>
                  <Row>
                    <RenderSelectInput
                      type="text"
                      display="Status"
                      name="status"
                      value={values.status}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.status}
                      touched={touched.status}
                      items={formData.statusOptions}
                      required
                    />
                  </Row>
                  <div className="d-flex align-items-center justify-content-center mt-3">
                    <button type="submit" className="btn btn-primary">
                      Save changes
                    </button>
                  </div>
                </form>
              </div>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default EditServiceAllocation;

// import {
//   RenderSelectInput,
//   RenderTextaera,
//   RenderTextInput,
// } from "app/common/renderInput";
// import { Formik } from "formik";
// import * as yup from "yup";
// import React, { Component } from "react";
// import { Row } from "react-bootstrap";
// import { NotificationManager } from "react-notifications";
// import serviceMasterService from "app/services/serviceMasterService";

// const { getServiceForUpdate, editService } = serviceMasterService;

// const validationModel = yup.object().shape({
//   serviceType: yup.string().required("Service Name is required!"),
//   serviceDescription: yup.string().required("Service Description is required!"),
//   status: yup.boolean().required("status is required!"),
// });

// export class EditServiceAllocation extends Component {
//   state = {
//     id: 0,
//     serviceType: "",
//     serviceDescription: "",
//     status: true,
//     statusOptions: [
//       { value: "true", label: "Active" },
//       { value: "false", label: "Inactive" },
//     ],
//   };

//   loadData = async (id) => {
//     const response = await getServiceForUpdate(id);
//     const data = response?.data;
//     console.log(data);
//     this.setState({
//       serviceType: data.serviceType,
//       serviceDescription: data.serviceDescription,
//       status: data.status,
//       id: data.id,
//     });
//   };
//   async componentWillReceiveProps(nextProps) {
//     if (nextProps?.id > 0 && this.state.id != nextProps?.id) {
//       await this.loadData(nextProps.id);
//     }
//   }

//   handleSubmit = async (values) => {
//     if (values.id > 0) {
//       let data = {
//         serviceType: values.serviceType,
//         serviceDescription: values.serviceDescription,
//         status: values.status,
//         id: values.id,
//       };
//       const response = await editService(data);

//       if (response.status === "Success") {
//         NotificationManager.success(response.message);
//         document.querySelectorAll(".close")[1].click();
//         this.props.loadNotification();
//         await this.loadData(this.state.id);
//       } else {
//         NotificationManager.error(response.message);
//       }
//     }
//   };

//   render() {
//     return (
//       <div
//         className="modal fade"
//         id="EditNotificationModal"
//         tabIndex="-1"
//         role="dialog"
//         aria-labelledby="addNewNotificationLabel"
//         aria-hidden="true"
//       >
//         <div className="modal-dialog modal-md" role="document">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title" id="addNewNotificationLabel">
//                 Edit Service Allocation
//               </h5>
//               <button
//                 type="button"
//                 className="close"
//                 data-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">&times;</span>
//               </button>
//             </div>
//             <Formik
//               onSubmit={this.handleSubmit}
//               initialValues={this.state}
//               validationSchema={validationModel}
//               enableReinitialize={true}
//             >
//               {({
//                 values,
//                 errors,
//                 touched,
//                 handleChange,
//                 handleBlur,
//                 handleSubmit,
//               }) => {
//                 return (
//                   <div className="modal-body">
//                     <form
//                       className="needs-validation"
//                       onSubmit={handleSubmit}
//                       noValidate
//                     >
//                       <Row>
//                         <RenderTextInput
//                           type="text"
//                           name="serviceType"
//                           display="Service Name"
//                           placeholder="Service Name"
//                           value={values.serviceType}
//                           error={errors.serviceType}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.serviceType}
//                           required
//                         ></RenderTextInput>
//                       </Row>
//                       <Row className="mb-2">
//                         <RenderTextaera
//                           name="serviceDescription"
//                           display="Service Description"
//                           placeholder="Service Description"
//                           value={values.serviceDescription}
//                           error={errors.serviceDescription}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           touched={touched.serviceDescription}
//                           required
//                         ></RenderTextaera>
//                       </Row>

//                       <Row>
//                         <RenderSelectInput
//                           type="text"
//                           display="Status"
//                           name="status"
//                           value={values.status}
//                           onChange={handleChange}
//                           onBlur={handleBlur}
//                           error={errors.status}
//                           touched={touched.status}
//                           items={this.state.statusOptions}
//                           required
//                         ></RenderSelectInput>
//                       </Row>
//                       <Row className="d-flex align-items-center justify-content-center mt-3">
//                         <button type="submit" className="btn btn-primary">
//                           Save changes
//                         </button>
//                       </Row>
//                     </form>
//                   </div>
//                 );
//               }}
//             </Formik>
//           </div>
//         </div>
//       </div>
//     );
//   }
// }

// export default EditServiceAllocation;
